// extracted by mini-css-extract-plugin
export default {"colorPrimary":"#2B5FF5","colorLoblolly":"#C5D0D8","mdBreak":"1024px","breadcrumbs":"cPRC4LK9TW9JWUwpeCZC","breadcrumbButton":"cGflIknHJIquJ4pKwBJQ","current":"iYS3BSQLyDUZAYxQ4heh"};